import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=f9086730&scoped=true"
var script = {}
import style0 from "./Verification.vue?vue&type=style&index=0&id=f9086730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9086730",
  null
  
)

export default component.exports